import { ChangeEvent, FocusEvent, FunctionComponent, useEffect, useState } from 'react';

import { FormField } from '../form-field/FormField';
import { FormControl } from '../models/FormControl';
import { ValidationErrorList } from '../validation/validation-error-list/ValidationErrorList';

import './ShortTextFormField.dark.scss';
import './ShortTextFormField.light.scss';

interface Props {
  /**
   * Label of this form field
   */
  label: string;

  /**
   * The model used to keep track of this form field's value
   */
  formControl: FormControl<string>;

  /**
   * Hint to the browsers to help them arrange the appropriate keyboard layout on mobile devices
   */
  type?: 'text' | 'email';
}

/**
 * This component renders an input field that spans only a single line,
 * it's used to collect input for short values, hence its name
 *
 * @param props
 * @returns
 */
export function ShortTextFormField({ label, type, formControl }: Props) {
  const [inputValue, setInputValue] = useState(formControl.getValue());
  const onInputValueChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputField = event.target;
    const newValue = inputField.value;

    setInputValue(newValue);
    formControl.setValue(newValue.trim());
  };
  const onBlur = (event: FocusEvent<HTMLInputElement>) => {
    if (formControl.isPristine()) {
      formControl.markDirty();
      formControl.setValue(event.target.value.trim());
    }
  };

  useEffect(() => {
    setInputValue(formControl.getValue());
  }, [formControl]);

  return (
    <FormField
      label={label}
      className='short-text-form-field'
      formControl={formControl}>
      <input
        className='short-text-form-field__input-field'
        type={type}
        value={inputValue}
        onBlur={onBlur}
        onChange={onInputValueChange} />
      <ValidationErrorList
        formLabel={label}
        formControl={formControl} />
    </FormField>
  );
}

(ShortTextFormField as FunctionComponent<Props>).defaultProps = {
  type: 'text'
};
